import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const whrfitnessApiService = createApi({
  reducerPath: "whrfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createWHR: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `whrfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getWHR: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `whrfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateWHR: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `whrfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateWHRMutation, useGetWHRQuery, useUpdateWHRMutation } =
  whrfitnessApiService;
